import { render, staticRenderFns } from "./change-security-pwd.vue?vue&type=template&id=6296df4e&scoped=true"
import script from "./change-security-pwd.vue?vue&type=script&lang=js"
export * from "./change-security-pwd.vue?vue&type=script&lang=js"
import style0 from "./change-security-pwd.vue?vue&type=style&index=0&id=6296df4e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6296df4e",
  null
  
)

export default component.exports